import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { VendorQuery } from '../store/vendor/vendor.query';

@Injectable({
  providedIn: 'root',
})
export class EditProfileRedirectGuardGuard  {
  public constructor(
    private vendorQuery: VendorQuery,
    private router: Router
  ) {}

  public canActivate(): boolean {
    const identifier =
      this.vendorQuery.alias ||
      this.vendorQuery.getValue().vendor.sustainmentId;
    this.router.navigate(['/profile', identifier]);
    return false;
  }
}
